module.exports = __webpack_public_path__ + "static/media/news-3.7f82325a.pdf";